/**
 * Selector de "Ancla de pago" (opcional) — la semántica cambia según la periodicidad:
 *   - Semanal / Catorcenal: día de la semana (ej. todos los LUNES).
 *   - Quincenal: convención mexicana "1 y 16" o "15 y último día del mes".
 *   - Mensual: día del mes 1–31 (si el mes no tiene ese día, cae al último día).
 * Sin ancla, el sistema deriva el día fijo de pago de la fecha de disposición al desembolsar
 * (dispone el 15 → paga los 15; mismo día del mes, sin drift; inhábil → siguiente día hábil).
 */
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const SIN_ANCLA = "__sin_ancla__";

const DIAS_SEMANA = [
  { value: "lunes", label: "Todos los lunes" },
  { value: "martes", label: "Todos los martes" },
  { value: "miercoles", label: "Todos los miércoles" },
  { value: "jueves", label: "Todos los jueves" },
  { value: "viernes", label: "Todos los viernes" },
  { value: "sabado", label: "Todos los sábados" },
  { value: "domingo", label: "Todos los domingos" },
];

const CONVENCIONES_QUINCENAL = [
  { value: "1y16", label: "Días 1 y 16 de cada mes" },
  { value: "15yUltimo", label: "Día 15 y último día del mes" },
];

export function opcionesAncla(periodicidad) {
  const p = String(periodicidad || "");
  if (p === "Semanal" || p === "Catorcenal") return DIAS_SEMANA;
  if (p === "Quincenal") return CONVENCIONES_QUINCENAL;
  if (p === "Mensual")
    return Array.from({ length: 31 }, (_, i) => ({
      value: String(i + 1),
      label: `Día ${i + 1} de cada mes${i + 1 >= 29 ? " (o último día del mes)" : ""}`,
    }));
  return null;
}

export function anclaLabel(periodicidad, value) {
  if (!value) return "";
  const opts = opcionesAncla(periodicidad) || [];
  const hit = opts.find((o) => String(o.value) === String(value));
  return hit ? hit.label : String(value);
}

export function AnclaPagoSelect({ periodicidad, value, onChange, testid = "select-ancla-pago", disabled = false }) {
  const opts = opcionesAncla(periodicidad);
  if (!opts)
    return (
      <div data-testid={`${testid}-na`}
        className="flex h-9 items-center rounded-md border border-slate-200 bg-slate-50 px-3 text-sm text-slate-400">
        {periodicidad ? "La periodicidad no admite ancla" : "Elige el producto / periodicidad primero"}
      </div>
    );
  return (
    <Select value={value ? String(value) : SIN_ANCLA} disabled={disabled}
      onValueChange={(v) => onChange(v === SIN_ANCLA ? "" : v)}>
      <SelectTrigger data-testid={testid}>
        <SelectValue placeholder="Automática — día de la fecha de disposición" />
      </SelectTrigger>
      <SelectContent className="max-h-72">
        <SelectItem value={SIN_ANCLA}>Automática — día de la fecha de disposición</SelectItem>
        {opts.map((o) => (
          <SelectItem key={o.value} value={o.value} data-testid={`${testid}-opt-${o.value}`}>{o.label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
